import { render, staticRenderFns } from "./PopupFilePreview.vue?vue&type=template&id=2d8a3147"
import script from "./PopupFilePreview.vue?vue&type=script&lang=ts"
export * from "./PopupFilePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports